export const DASHBOARD_CONSTANT = {
  // TABLE
  MEMBER_COUNT_CSV_TABLE: "member_summary_member",
  PWD_SETTING_U_CSV_TABLE: "user_summary_member",
  PWD_SETTING_UU_CSV_TABLE: "user_summary_member_user",
  MONTH_LOGIN_U_CSV_TABLE: "login_summary_member",
  MONTH_LOGIN_UU_CSV_TABLE: "login_summary_member_user",
  AGENDA_REGIST_ORGANIZATION_CSV_TABLE: "agenda_solution_summary_member",
  AGENDA_REGIST_CSV_TABLE: "agenda_solution_summary_member_agenda_so",
  SOLUTION_REGIST_CSV_TABLE: "agenda_solution_summary_member_agenda_so",
  SUGGEST_REGIST_CSV_TABLE: "suggest_summary_m_a_s",
  OPINION_EXCHANGE_CSV_TABLE: "suggest_match_summary_m_a_s",
  COOPERATION_START_CSV_TABLE: "industrialization_report_summary_m_a_s",
  //集計テーブル/ビュー
  MEMBER_COUNT_SUMCSV_TABLE: "sum_kaiin_su",
  PWD_SETTING_U_SUMCSV_TABLE: "sum_idpwd_su",
  PWD_SETTING_UU_SUMCSV_TABLE: "sum_idpwd_su",
  MONTH_LOGIN_U_SUMCSV_TABLE: "sum_login_su",
  MONTH_LOGIN_UU_SUMCSV_TABLE: "sum_login_su",
  AGENDA_REGIST_ORGANIZATION_SUMCSV_TABLE: "sum_kadai_toroku_rui",
  AGENDA_REGIST_SUMCSV_TABLE: "sum_agenda_su",
  SOLUTION_REGIST_SUMCSV_TABLE: "sum_solution_su",
  SUGGEST_REGIST_SUMCSV_TABLE: "sum_teian_toroku_su",
  OPINION_EXCHANGE_SUMCSV_TABLE: "sum_iken_koukan_su",
  COOPERATION_START_SUMCSV_TABLE: "sum_renkei_kaishi",

  // csvファイル名
  // 会員分析の明細
  MEMBER_COUNT_CSV_FILENAME: '会員数の明細',
  PWD_SETTING_U_CSV_FILENAME: 'ID_PWD設定済U団体数の明細',
  PWD_SETTING_UU_CSV_FILENAME: 'ID_PWD設定済UU数の明細',
  MONTH_LOGIN_U_CSV_FILENAME: '月間ログインU団体数の明細',
  MONTH_LOGIN_UU_CSV_FILENAME: '月間ログインUU数の明細',
  AGENDA_REGIST_ORGANIZATION_CSV_FILENAME: '課題登録団体数(累計)の明細',
  //会員分析の集計
  MEMBER_COUNT_SUMCSV_FILENAME: '会員数の集計',
  PWD_SETTING_U_SUMCSV_FILENAME: 'ID_PWD設定済U団体数の集計',
  PWD_SETTING_UU_SUMCSV_FILENAME: 'ID_PWD設定済UU数の集計',
  MONTH_LOGIN_U_SUMCSV_FILENAME: '月間ログインU団体数の集計',
  MONTH_LOGIN_UU_SUMCSV_FILENAME: '月間ログインUU数の集計',
  AGENDA_REGIST_ORGANIZATION_SUMCSV_FILENAME: '課題登録団体数(累計)の集計',
  // マッチングボトルネック分析の明細
  AGENDA_REGIST_CSV_FILENAME: '課題登録件数の明細',
  SOLUTION_REGIST_CSV_FILENAME: 'ソリューション登録件数の明細',
  SUGGEST_REGIST_CSV_FILENAME: '提案登録件数の明細',
  OPINION_EXCHANGE_CSV_FILENAME: '意見交換希望件数の明細',
  COOPERATION_START_CSV_FILENAME: '連携開始件数の明細',
  // マッチングボトルネック分析の集計
  AGENDA_REGIST_SUMCSV_FILENAME: '課題登録件数の集計',
  SOLUTION_REGIST_SUMCSV_FILENAME: 'ソリューション登録件数の集計',
  SUGGEST_REGIST_SUMCSV_FILENAME: '提案登録件数の集計',
  OPINION_EXCHANGE_SUMCSV_FILENAME: '意見交換希望件数の集計',
  COOPERATION_START_SUMCSV_FILENAME: '連携開始件数の集計',

  // zipファイル名
  MEMBER_SUMMARY_ZIP_FILENAME: '会員分析明細',
  MATCHING_SUMMARY_ZIP_FILENAME: 'マッチングボトルネック分析明細',
  MEMBER_SUMMARY_TOTAL_ZIP_FILENAME: '会員分析集計',
  MATCHING_SUMMARY_TOTAL_ZIP_FILENAME: 'マッチングボトルネック分析集計',
};